import emptySliceApi from '../../../../../shared/store/emptyApiSlice';
import { InternalAdminModel } from '../models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    inviteInternalAdmin: builder.mutation<
      InternalAdminModel,
      {
        email: string;
        roleType: string;
      }
    >({
      query: ({ email, roleType }) => ({
        url: `v4/poweradmins`,
        method: 'POST',
        body: { email, roleType },
      }),
      invalidatesTags: ['Admin'],
    }),
    updateInternalAdmin: builder.mutation<
      InternalAdminModel,
      {
        id?: number;
        personId?: number;
        inviteCode?: string;
        email?: string;
        accountUserId: string;
        roleType: string;
      }
    >({
      query: ({
        id,
        personId,
        inviteCode,
        accountUserId,
        roleType,
        email,
      }) => ({
        url: `v4/poweradmins`,
        method: 'PUT',
        body: { id, personId, inviteCode, accountUserId, roleType, email },
      }),
      invalidatesTags: ['Admin'],
    }),
  }),
});

export const {
  useInviteInternalAdminMutation,
  useUpdateInternalAdminMutation,
} = apiSlice;
